var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyRefreshWorkflow = function SvgSurveyRefreshWorkflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 116,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#87a5d1",
    strokeDasharray: "0.27 2.16",
    strokeLinecap: "round",
    strokeWidth: 0.811,
    d: "M52.37 31.04H68m21.564 24.468v15.066M52.826 87.68h14.832",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M59.785 32.512c.82 0 1.483-.66 1.483-1.473s-.664-1.473-1.483-1.473-1.483.66-1.483 1.473.664 1.473 1.483 1.473"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M89.564 64.004c.819 0 1.483-.66 1.483-1.473s-.664-1.472-1.483-1.472-1.483.659-1.483 1.472c0 .814.664 1.473 1.483 1.473"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M59.785 89.152c.82 0 1.483-.659 1.483-1.472 0-.814-.664-1.473-1.483-1.473s-1.483.66-1.483 1.473.664 1.472 1.483 1.472"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#eef2f7",
    strokeWidth: 0.5,
    d: "M48.718 9.063H12.322c-1.764 0-3.194 1.42-3.194 3.172v39.761c0 1.752 1.43 3.172 3.194 3.172h36.396c1.764 0 3.195-1.42 3.195-3.172V12.234c0-1.751-1.43-3.171-3.195-3.171Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M23.161 13.707h-7.53a1.82 1.82 0 0 0-1.826 1.813v7.476a1.82 1.82 0 0 0 1.826 1.813h7.53a1.82 1.82 0 0 0 1.826-1.813V15.52a1.82 1.82 0 0 0-1.826-1.813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.772 15.746h3.537l2.168 2.152v4.758h-5.705z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ddf8ef",
    strokeLinejoin: "round",
    strokeWidth: 0.541,
    d: "M20.309 15.746v2.266h2.168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6d1e5",
    d: "M41.302 16.766H28.98a.68.68 0 0 0-.685.68c0 .375.307.679.685.679h12.322a.68.68 0 0 0 .685-.68.68.68 0 0 0-.685-.68m4.222 3.625H28.98a.68.68 0 0 0-.685.68c0 .376.307.68.685.68h16.543a.68.68 0 0 0 .685-.68.68.68 0 0 0-.684-.68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M18.37 28.887h-3.538a.91.91 0 0 0-.913.906v3.512c0 .5.41.906.913.906h3.537a.91.91 0 0 0 .913-.906v-3.512a.91.91 0 0 0-.913-.906"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.811,
    d: "m15.517 31.492 1.027 1.02 1.597-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M44.04 29.906H22.705a.455.455 0 0 0-.457.453c0 .25.205.453.457.453H44.04a.455.455 0 0 0 .457-.453.455.455 0 0 0-.457-.453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5d0e3",
    d: "M37.366 32.738H22.762a.51.51 0 0 0-.514.51c0 .282.23.51.514.51h14.604a.51.51 0 0 0 .513-.51c0-.281-.23-.51-.513-.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#c9d6ea",
    strokeWidth: 0.541,
    d: "M18.37 37.383h-3.538a.91.91 0 0 0-.913.906v3.512c0 .5.41.906.913.906h3.537a.91.91 0 0 0 .913-.906v-3.512a.91.91 0 0 0-.913-.906Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5d0e3",
    d: "M44.44 38.403H22.762a.51.51 0 0 0-.514.51c0 .28.23.509.514.509H44.44a.51.51 0 0 0 .513-.51c0-.281-.23-.51-.513-.51m-8.101 3.059H22.762a.51.51 0 0 0-.514.51c0 .281.23.51.514.51h13.577a.51.51 0 0 0 .513-.51c0-.282-.23-.51-.513-.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#c9d6ea",
    strokeWidth: 0.541,
    d: "M18.37 45.766h-3.538a.91.91 0 0 0-.913.906v3.512c0 .5.41.906.913.906h3.537a.91.91 0 0 0 .913-.906v-3.512a.91.91 0 0 0-.913-.906Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5d0e3",
    d: "M43.87 46.785H22.761a.51.51 0 0 0-.514.51c0 .282.23.51.514.51h21.107a.51.51 0 0 0 .514-.51c0-.282-.23-.51-.514-.51m-7.529 3.059H22.762a.51.51 0 0 0-.514.51c0 .281.23.51.514.51h13.577a.51.51 0 0 0 .513-.51c0-.282-.23-.51-.513-.51"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#eef2f7",
    strokeWidth: 0.5,
    d: "M106.45 11.895H71.423c-1.89 0-3.423 1.521-3.423 3.398v36.59c0 1.877 1.532 3.398 3.423 3.398h35.027c1.89 0 3.422-1.521 3.422-3.398v-36.59c0-1.877-1.532-3.398-3.422-3.398Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M68 15.293q0-3.398 3.423-3.398h35.027q3.422 0 3.422 3.398v3.852H68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M78.269 9.969c0-.814-.665-1.473-1.484-1.473s-1.483.66-1.483 1.473v4.87c0 .814.664 1.473 1.483 1.473s1.484-.659 1.484-1.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.785 18.465a1.82 1.82 0 0 0 1.826-1.813 1.82 1.82 0 0 0-1.826-1.812 1.82 1.82 0 0 0-1.825 1.812 1.82 1.82 0 0 0 1.825 1.813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M78.269 9.969c0-.814-.665-1.473-1.484-1.473s-1.483.66-1.483 1.473v4.191c0 .813.664 1.473 1.483 1.473s1.484-.66 1.484-1.473z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M102 9.969c0-.814-.664-1.473-1.483-1.473s-1.483.66-1.483 1.473v4.87c0 .814.664 1.473 1.483 1.473S102 15.653 102 14.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100.517 18.465a1.82 1.82 0 0 0 1.825-1.813 1.82 1.82 0 0 0-1.825-1.812 1.82 1.82 0 0 0-1.826 1.812 1.82 1.82 0 0 0 1.826 1.813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M102 9.969c0-.814-.664-1.473-1.483-1.473s-1.483.66-1.483 1.473v4.191c0 .813.664 1.473 1.483 1.473S102 14.973 102 14.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eef2f7",
    d: "M77.128 23.223h-3.766c-.63 0-1.14.507-1.14 1.133v3.738c0 .625.51 1.133 1.14 1.133h3.766c.63 0 1.14-.508 1.14-1.133v-3.739c0-.625-.51-1.132-1.14-1.132m8.671 0h-3.766c-.63 0-1.14.507-1.14 1.133v3.738c0 .625.51 1.133 1.14 1.133H85.8c.63 0 1.14-.508 1.14-1.133v-3.739c0-.625-.51-1.132-1.14-1.132m8.67 0h-3.765c-.63 0-1.141.507-1.141 1.133v3.738c0 .625.51 1.133 1.14 1.133h3.766c.63 0 1.14-.508 1.14-1.133v-3.739c0-.625-.51-1.132-1.14-1.132m8.671 0h-3.765c-.63 0-1.141.507-1.141 1.133v3.738c0 .625.51 1.133 1.14 1.133h3.766c.63 0 1.141-.508 1.141-1.133v-3.739c0-.625-.511-1.132-1.141-1.132m-26.013 8.722h-3.766c-.63 0-1.14.508-1.14 1.133v3.738c0 .626.51 1.133 1.14 1.133h3.766c.63 0 1.14-.507 1.14-1.133v-3.738c0-.626-.51-1.133-1.14-1.133m8.671 0h-3.766c-.63 0-1.14.508-1.14 1.133v3.738c0 .626.51 1.133 1.14 1.133H85.8c.63 0 1.14-.507 1.14-1.133v-3.738c0-.626-.51-1.133-1.14-1.133m17.341 0h-3.765c-.63 0-1.141.508-1.141 1.133v3.738c0 .626.51 1.133 1.14 1.133h3.766c.63 0 1.141-.507 1.141-1.133v-3.738c0-.626-.511-1.133-1.141-1.133m-26.013 8.723h-3.766c-.63 0-1.14.507-1.14 1.133v3.738c0 .626.51 1.133 1.14 1.133h3.766c.63 0 1.14-.507 1.14-1.133v-3.738c0-.626-.51-1.133-1.14-1.133m8.671 0h-3.766c-.63 0-1.14.507-1.14 1.133v3.738c0 .626.51 1.133 1.14 1.133H85.8c.63 0 1.14-.507 1.14-1.133v-3.738c0-.626-.51-1.133-1.14-1.133m8.67 0h-3.765c-.63 0-1.141.507-1.141 1.133v3.738c0 .626.51 1.133 1.14 1.133h3.766c.63 0 1.14-.507 1.14-1.133v-3.738c0-.626-.51-1.133-1.14-1.133m8.671 0h-3.765c-.63 0-1.141.507-1.141 1.133v3.738c0 .626.51 1.133 1.14 1.133h3.766c.63 0 1.141-.507 1.141-1.133v-3.738c0-.626-.511-1.133-1.141-1.133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ddf7ef",
    d: "M95.04 30.586h-4.906a1.82 1.82 0 0 0-1.825 1.812v4.871c0 1.002.817 1.813 1.825 1.813h4.906a1.82 1.82 0 0 0 1.826-1.812v-4.872a1.82 1.82 0 0 0-1.826-1.812"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00b77a",
    strokeWidth: 0.811,
    d: "M92.587 37.893c1.702 0 3.08-1.37 3.08-3.059s-1.378-3.059-3.08-3.059a3.07 3.07 0 0 0-3.08 3.06c0 1.688 1.379 3.058 3.08 3.058Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00b77a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.811,
    d: "M92.644 32.852v2.152l1.483.906"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#eef2f7",
    strokeWidth: 0.5,
    d: "M49.06 68.988H12.436c-1.764 0-3.194 1.42-3.194 3.172v31.606c0 1.752 1.43 3.172 3.194 3.172H49.06c1.765 0 3.195-1.42 3.195-3.172V72.16c0-1.751-1.43-3.172-3.195-3.172Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#8ba7cf",
    strokeWidth: 0.406,
    d: "M13.12 86.774h20.766"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M17.456 82.695h-1.825a.57.57 0 0 0-.57.567v2.945c0 .313.255.567.57.567h1.825c.316 0 .57-.254.57-.567v-2.945a.57.57 0 0 0-.57-.567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M21.906 79.75h-1.825a.57.57 0 0 0-.57.567v5.89c0 .313.255.567.57.567h1.825c.315 0 .57-.254.57-.567v-5.89a.57.57 0 0 0-.57-.567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M26.356 76.352H24.53a.57.57 0 0 0-.57.566v9.29c0 .312.255.566.57.566h1.826c.315 0 .57-.254.57-.567v-9.289a.57.57 0 0 0-.57-.566"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55cda7",
    d: "M30.805 73.746H28.98a.57.57 0 0 0-.57.567v11.894c0 .313.255.567.57.567h1.825c.315 0 .57-.254.57-.567V74.313a.57.57 0 0 0-.57-.567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M13.007 102.067c4.906-4.985 7.758-2.266 12.094-3.625 5.134-1.586 7.986-4.305 11.98-2.38 3.765 1.813 6.275 1.02 11.067-5.21v11.215z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00b77a",
    strokeLinecap: "round",
    strokeWidth: 0.541,
    d: "M13.007 102.067c4.906-4.985 7.758-2.266 12.094-3.625 5.134-1.586 7.986-4.305 11.98-2.38 3.765 1.813 6.275 1.02 11.067-5.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b77a",
    d: "M48.148 91.418c.315 0 .57-.254.57-.566a.57.57 0 0 0-.57-.567.57.57 0 0 0-.57.567c0 .312.255.566.57.566"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#eef2f7",
    strokeWidth: 0.5,
    d: "M106.678 68.875H71.195c-1.765 0-3.195 1.42-3.195 3.172v31.719c0 1.751 1.43 3.171 3.195 3.171h35.483c1.764 0 3.194-1.42 3.194-3.171v-31.72c0-1.75-1.43-3.171-3.194-3.171Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M76.557 76.578h-3.65c-.568 0-1.028.457-1.028 1.02v3.625c0 .563.46 1.02 1.027 1.02h3.651c.567 0 1.027-.457 1.027-1.02v-3.625c0-.563-.46-1.02-1.027-1.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.811,
    d: "m73.477 79.41 1.026 1.02 1.712-2.266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5d0e3",
    d: "M93.614 77.938H80.722a.51.51 0 0 0-.514.51c0 .28.23.509.514.509h12.892a.51.51 0 0 0 .513-.51c0-.281-.23-.51-.513-.51m-2.966 2.946h-9.926a.51.51 0 0 0-.514.51c0 .281.23.51.514.51h9.926a.51.51 0 0 0 .513-.51c0-.282-.23-.51-.513-.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M76.557 86.094h-3.65c-.568 0-1.028.456-1.028 1.02v3.624c0 .563.46 1.02 1.027 1.02h3.651c.567 0 1.027-.457 1.027-1.02v-3.625c0-.563-.46-1.02-1.027-1.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.811,
    d: "m73.477 88.926 1.026 1.02 1.712-2.266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5d0e3",
    d: "M98.064 87.453H80.722a.51.51 0 0 0-.514.51c0 .281.23.51.514.51h17.342a.51.51 0 0 0 .513-.51c0-.282-.23-.51-.513-.51m-7.416 2.945h-9.926a.51.51 0 0 0-.514.51c0 .282.23.51.514.51h9.926a.51.51 0 0 0 .513-.51c0-.281-.23-.51-.513-.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M76.557 95.61h-3.65c-.568 0-1.028.456-1.028 1.019v3.625c0 .563.46 1.019 1.027 1.019h3.651c.567 0 1.027-.456 1.027-1.019v-3.625c0-.563-.46-1.02-1.027-1.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.811,
    d: "m73.477 98.441 1.026 1.02 1.712-2.266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5d0e3",
    d: "M98.064 96.969H80.722a.51.51 0 0 0-.514.51c0 .281.23.51.514.51h17.342a.51.51 0 0 0 .513-.51c0-.282-.23-.51-.513-.51m-7.416 2.945h-9.926a.51.51 0 0 0-.514.51c0 .281.23.51.514.51h9.926a.51.51 0 0 0 .513-.51c0-.282-.23-.51-.513-.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4fcf9",
    stroke: "#bfebdd",
    strokeWidth: 0.406,
    d: "M101.201 82.469c2.332 0 4.222-1.877 4.222-4.192 0-2.314-1.89-4.191-4.222-4.191-2.331 0-4.221 1.877-4.221 4.191s1.89 4.192 4.221 4.192Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00b77a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.946,
    d: "m99.148 78.39 1.369 1.473 2.738-3.511"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M47.323 82.88a6.2 6.2 0 0 1-2.2 2.224 6.25 6.25 0 0 1-8.4-1.921 6.15 6.15 0 0 1-.413-6.02 6.2 6.2 0 0 1 2.017-2.389 6.25 6.25 0 0 1 2.936-1.106l.533 4.911a1.25 1.25 0 0 0-.99.699 1.227 1.227 0 0 0 .547 1.623 1.25 1.25 0 0 0 1.655-.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M47.317 76.724a6.14 6.14 0 0 1 .29 5.599l-4.542-2.013a1.23 1.23 0 0 0-.058-1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6d1e5",
    d: "M41.93 73.633c.98 0 1.948.23 2.822.673a6.2 6.2 0 0 1 2.208 1.872l-4.024 2.903a1.24 1.24 0 0 0-1.007-.51z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 58.302,
    x2: 61.247,
    y1: 29.566,
    y2: 32.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 88.081,
    x2: 91.026,
    y1: 61.059,
    y2: 64.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 58.302,
    x2: 61.247,
    y1: 86.207,
    y2: 89.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 13.805,
    x2: 24.907,
    y1: 13.707,
    y2: 24.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 13.919,
    x2: 19.244,
    y1: 28.887,
    y2: 34.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 22.248,
    x2: 44.497,
    y1: 29.906,
    y2: 29.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5a87c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ea2d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 68,
    x2: 70.438,
    y1: 11.895,
    y2: 25.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 75.302,
    x2: 80.488,
    y1: 8.496,
    y2: 10.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0c4b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 75.302,
    x2: 80.361,
    y1: 8.496,
    y2: 10.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0c4b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 99.034,
    x2: 104.22,
    y1: 8.496,
    y2: 10.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0c4b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 99.034,
    x2: 104.092,
    y1: 8.496,
    y2: 10.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0c4b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 15.06,
    x2: 18.94,
    y1: 82.695,
    y2: 85.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 19.51,
    x2: 24.545,
    y1: 79.75,
    y2: 81.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 23.96,
    x2: 29.448,
    y1: 76.352,
    y2: 77.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 13.007,
    x2: 13.007,
    y1: 90.852,
    y2: 102.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bdefe3",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaf8f4",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 71.879,
    x2: 77.543,
    y1: 76.578,
    y2: 82.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 71.879,
    x2: 77.543,
    y1: 86.094,
    y2: 91.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 71.879,
    x2: 77.543,
    y1: 95.609,
    y2: 101.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 35.711,
    x2: 48.059,
    y1: 73.633,
    y2: 86.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0c4b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 35.711,
    x2: 48.059,
    y1: 73.633,
    y2: 86.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17d0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a86b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 59.285,
    height: 62.605,
    x: 0.878,
    y: 4.813,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7429_87626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7429_87626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    width: 58.373,
    height: 59.887,
    x: 59.75,
    y: 7.645,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7429_87626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7429_87626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    width: 59.513,
    height: 54.449,
    x: 0.992,
    y: 64.738,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7429_87626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7429_87626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    width: 58.373,
    height: 54.563,
    x: 59.75,
    y: 64.625,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7429_87626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7429_87626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v116H0z"
  })))));
};
export default SvgSurveyRefreshWorkflow;